import { render, staticRenderFns } from "./TreinamentoIA.vue?vue&type=template&id=e10d24b6&scoped=true"
import script from "./TreinamentoIA.vue?vue&type=script&lang=js"
export * from "./TreinamentoIA.vue?vue&type=script&lang=js"
import style0 from "./TreinamentoIA.vue?vue&type=style&index=0&id=e10d24b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10d24b6",
  null
  
)

export default component.exports